import React, {Component} from 'react';
import IconHeart from "./icons/IconHeart";
import {CONFIG} from "../../search-results/config";

import '@assets/sass/components/apartment-like.scss';

export default class ApartmentLike extends Component {
    state = {
        active: false
    }

    componentDidMount() {
        this.setState({
            active: this.props.active
        })
    }

    toggleLike = () => {
        this.setState({
            active: !this.state.active
        })
    }

    handleClick = () => {
        this.toggleLike();
        try {
            fetch(CONFIG.UPDATE_FAVOURITE + this.props.apartmentId, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                return response.json()
            }).catch(error => {
                this.toggleLike();
            })
        } catch (error) {
            this.toggleLike();
        }
    }

    render() {
        return (
            <button className="favourite" onClick={this.handleClick}>
                <IconHeart active={this.state.active}/>
            </button>
        );
    }
}
